import { AuthHeroPanel } from './AuthHeroPanel';

export function AuthCarousel() {
    return <AuthHeroPanel />;
}
